

import { request } from "@weapp/utils";
import { mainHost } from "../../utils";

const userId = window.TEAMS?.currentUser?.userId

//获取推荐详细
export const getRecommendInfo = (pageNo: number | string, pageSize: number | string) => {
    return request({
        url: `/api/basicserver/inviteteams/findInviteTeams?&userId=${userId}`,
        method: "get",
    });
};

//获取推荐首页信息
export const getInviteTeams = () => {
    return request({
        url: `/api/basicserver/inviteteams/findInviteRuleInfo?&userId=${userId}`,
        method: "get",
    });
};
